import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import VueCountdown from '@chenfengyuan/vue-countdown';
import { Component, Emit, Prop, Ref, Vue } from "vue-facing-decorator";
let Timer = class Timer extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "timer", void 0);
    // in seconds
    _defineProperty(this, "overallMilliseconds", 0);
    _defineProperty(this, "countdownComponent", void 0);
  }
  mounted() {
    this.overallMilliseconds = this.timer * 1000;
  }
  startCounting() {
    this.countdownComponent.start();
  }
  stopCounting() {
    this.countdownComponent.abort();
  }
  getRemainingSeconds() {
    return this.countdownComponent.totalSeconds;
  }
  progressPercentage(remainingMilliseconds) {
    return remainingMilliseconds / this.overallMilliseconds * 100;
  }
  onCountdownEnd() {
    return this.getRemainingSeconds();
  }
};
__decorate([Prop({
  default: 0
})], Timer.prototype, "timer", void 0);
__decorate([Ref('countdownComponent')], Timer.prototype, "countdownComponent", void 0);
__decorate([Emit('countdownEnd')], Timer.prototype, "onCountdownEnd", null);
Timer = __decorate([Component({
  components: {
    VueCountdown
  }
})], Timer);
export default Timer;